import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[psMultiCountryRowHoverContent]',
})
export class MultiCountryRowHoverContentDirective {
  constructor(public template: TemplateRef<unknown>) {}
}
